module.exports = "../images/forest@2x.jpg?v=628f327";